<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="toc">
<p class="ct">Contents</p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop004#ded">Dedication</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop006#acknowledgments">Acknowledgments</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop007#familytree">The Family Tree</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop008#ch01">Chapter 1</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop009#ch02">Chapter 2</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop010#ch03">Chapter 3</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop011#ch04">Chapter 4</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop012#ch05">Chapter 5</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop013#ch06">Chapter 6</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop014#ch07">Chapter 7</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop015#ch08">Chapter 8</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop016#ch09">Chapter 9</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop017#ch10">Chapter 10</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop018#ch11">Chapter 11</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop019#ch12">Chapter 12</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop020#ch13">Chapter 13</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop021#ch14">Chapter 14</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop022#ch15">Chapter 15</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop023#ch16">Chapter 16</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop024#ch17">Chapter 17</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop025#ch18">Chapter 18</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop026#ch19">Chapter 19</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop027#recipes">Alafair’s Recipes</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop028#glossary">Compendium</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop029#moreauth">More from this Author</a></p>
<p class="tocfm"><a class="calibre2" href="#/OEBPS/pppdrop030#contactus">Contact Us</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-drop005.vue?0eb11b32